export default __webpack_public_path__ + "static/media/jeffrey_rosenfeld.71d5d5c4.jpg";